<ng-container *ngFor="let mapEntry of entitiesMapEntries">
  <div *ngIf="mapEntry[1]?.length" class="d-flex mb-1">
    <div style="width: 60px !important" class="font-weight-bold">
      {{ mapEntry[0] | enumFormat : '_' }}:
    </div>
    <div class="flex-grow-1 d-flex flex-column">
      <span
        *ngFor="let entity of mapEntry[1]"
        class="text-success text-hover-warning cursor"
        (click)="openEntityOffcanvas(entity.entity_type, entity.entity_id)"
      >
        <small>{{
          entity.name || ((entity.first_name || '') + ' ' + (entity.last_name || '')).trim()
        }}</small>
        <small
          *ngIf="entity.entity_type === TaskEntityType.PATIENT && !!entity.external_id"
          class="ml-2"
        >
          ({{ entity.external_id }})
        </small>
      </span>
    </div>
  </div>
</ng-container>
